import { UTMInfoUI } from 'components/UTMInfoUI';
import { useOutletContext } from 'react-router-dom';

export const UTMInfo = () => {
  const { profileData }: { profileData: any } = useOutletContext();

  return <UTMInfoUI utmInfo={profileData?.utm_info} />;
};
